import { render, staticRenderFns } from "./CrmAnalytics.vue?vue&type=template&id=f4290cf6&scoped=true"
import script from "./CrmAnalytics.vue?vue&type=script&lang=js"
export * from "./CrmAnalytics.vue?vue&type=script&lang=js"
import style0 from "./CrmAnalytics.vue?vue&type=style&index=0&id=f4290cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4290cf6",
  null
  
)

export default component.exports